import React from 'react';
import Plans from '../../../pages/Plans';
import Features from '../../../pages/Features';
import Book from '../../../pages/Book';
import Portfolio from '../../../pages/Portfolio';
import HiddenVersion from '../../../pages/HiddenVersion';
import CheckoutRedirect from '../../../pages/CheckoutRedirect';
import Blog from '../../../pages/Blog';
import BlogPost from '../../../pages/BlogPost';
import VendorApply from '../../../pages/VendorApply';

export const otherRoutes = [
  { path: '/plans', element: <Plans /> },
  { path: '/features', element: <Features /> },
  { path: '/book', element: <Book /> },
  { path: '/portfolio', element: <Portfolio /> },
  { path: '/hidden/version', element: <HiddenVersion /> },
  { path: '/hidden/checkout/9B600ce30cGGdF63N2gQE03', element: <CheckoutRedirect /> },
  { path: '/blog', element: <Blog /> },
  { path: '/blog/:slug', element: <BlogPost /> },
  { path: '/vendors', element: <VendorApply /> }
];
